/**
 * Message types (Log, error, points, etc)
 * @typedef {string} MessageType
 */
export const MESSAGE_TYPE_ERROR = 'MESSAGE_TYPE_ERROR'
export const MESSAGE_TYPE_LOG = 'MESSAGE_TYPE_LOG'
export const MESSAGE_TYPE_SUCCESS = 'MESSAGE_TYPE_SUCCESS'

/**
 * Message params
 */
export const LAST_MESSAGE_COUNT = 2
export const MESSAGE_TIME_IN_SECONDS = 3

export const ADD_MESSAGE = 'ADD_MESSAGE'
export const HIDE_MESSAGE = 'HIDE_MESSAGE'


